import React from 'react';

import CommonImage from '@components/CommonImage';

const CostingFields = ({
	inputData,
	increaseCostField,
	setIncreaseCostField,
	handleChange,
	prevTarget,
	isCostingManager,
	isValidInput,
	resetAll,
	fetchCostInfoFromCostField,
	updateCosting,
	showMore,
	setShowMore,
	validateFloatNumber,
	readOnly,
	setMemberId,
	selectedPriceRangeStatus,
	handleDropdownChange,
	COSTING_DROPDOWN_OPTIONS
}) => {
	const filterOutOptions = ['TARGET_PRICE_MISSING', 'IN_RANGE', 'OUT_OF_RANGE'];
	return (
		<div className="costing-items-details">
			<div className="costing-items-row d-flex align-items-center">
				<div className="left-half">
					<span className="semibold-14 gray_dark_01">COSTING</span>
				</div>
				<div className="right-half">
					<div class="option">
						<div class="dropdown">
							<button
								class="btn btn-default p-0 dropdown-toggle"
								type="button"
								id="menu1"
								data-toggle="dropdown"
								aria-expanded="false"
							>
								<span className={`regular-14 ${selectedPriceRangeStatus?.className} mr-1`}>
									{selectedPriceRangeStatus?.label || 'Select'}
								</span>
								<CommonImage
									src="/images/chevron_down.svg"
									alt="chevron_down"
									isStatic={true}
								/>
							</button>
							<ul
								class="dropdown-menu dropdown-menu-right shadow-8dp"
								role="menu"
								aria-labelledby="menu1"
								x-placement="bottom-end"
							>
								{COSTING_DROPDOWN_OPTIONS?.filter(
									(option) => !filterOutOptions.includes(option?.value)
								)?.map((option) => (
									<li
										onClick={() => handleDropdownChange(option)}
										role="presentation"
										class="px-4 pb-3 pt-3"
										key={`dropdown_${option?.value}`}
									>
										<a
											role="menuitem"
											tabindex="-1"
											class="font-weight-normal  text-black"
										>
											{option?.label}
										</a>
									</li>
								))}
							</ul>
						</div>
					</div>
				</div>
			</div>
			<div className="costing-items-row d-flex align-items-center">
				<div className="left-half">
					<span className="regular-14 gray_dark_01">COST</span>
				</div>
				<div className="right-half">
					<input
						type="text"
						autoComplete="off"
						placeholder="Fabric, Trims, Print..."
						className={increaseCostField ? 'w-100' : ''}
						disabled={!isCostingManager()}
						name="allCostsAsString"
						value={inputData?.allCostsAsString || ''}
						onClick={() => setIncreaseCostField(true)}
						onChange={(e) => handleChange(e, setMemberId)}
						onFocus={(event) => (prevTarget.current = event.target.value)}
						onBlur={(event) => {
							if (!isValidInput(prevTarget, event)) {
								resetAll();
								return;
							}
							fetchCostInfoFromCostField(setMemberId && setMemberId);
						}}
					/>
				</div>
			</div>
			<div className="costing-items-row d-flex align-items-center">
				<div className="left-half">
					<span className="regular-14 gray_dark_02">Fabric*</span>
				</div>
				<div className="right-half">
					<input
						type="number"
						placeholder="$00.00"
						disabled={readOnly}
						name="fabricUnitCost"
						value={inputData?.fabricUnitCost || ''}
						onKeyPress={validateFloatNumber}
						onChange={(e) => handleChange(e, setMemberId)}
						onFocus={(event) => (prevTarget.current = event.target.value)}
						onBlur={(event) => {
							if (!isValidInput(prevTarget, event)) {
								resetAll();
								return;
							}
							updateCosting(event, setMemberId);
						}}
						min={0}
					/>
				</div>
			</div>
			<div className="costing-items-row d-flex align-items-center">
				<div className="left-half">
					<span className="regular-14 gray_dark_02">Trims*</span>
				</div>
				<div className="right-half">
					<input
						type="number"
						placeholder="$00.00"
						disabled={readOnly}
						name="trimsCost"
						onKeyPress={validateFloatNumber}
						value={inputData?.trimsCost || ''}
						onChange={(e) => handleChange(e, setMemberId)}
						onFocus={(event) => (prevTarget.current = event.target.value)}
						onBlur={(event) => {
							if (!isValidInput(prevTarget, event)) {
								resetAll();
								return;
							}
							updateCosting(event, setMemberId);
						}}
						min={0}
					/>
				</div>
			</div>
			{showMore && (
				<>
					<div className="costing-items-row d-flex align-items-center">
						<div className="left-half">
							<span className="regular-14 gray_dark_02">Print & Embroidery</span>
						</div>
						<div className="right-half">
							<input
								type="number"
								placeholder="$00.00"
								disabled={readOnly}
								name="embellishmentCost"
								onKeyPress={validateFloatNumber}
								value={inputData?.embellishmentCost || ''}
								onChange={(e) => handleChange(e, setMemberId)}
								onFocus={(event) => (prevTarget.current = event.target.value)}
								onBlur={(event) => {
									if (!isValidInput(prevTarget, event)) {
										resetAll();
										return;
									}
									updateCosting(event, setMemberId);
								}}
								min={0}
							/>
						</div>
					</div>
					<div className="costing-items-row d-flex align-items-center">
						<div className="left-half">
							<span className="regular-14 gray_dark_02">Washing</span>
						</div>
						<div className="right-half">
							<input
								type="number"
								placeholder="$00.00"
								disabled={readOnly}
								name="washCost"
								value={inputData?.washCost || ''}
								onKeyPress={validateFloatNumber}
								onChange={(e) => handleChange(e, setMemberId)}
								onFocus={(event) => (prevTarget.current = event.target.value)}
								onBlur={(event) => {
									if (!isValidInput(prevTarget, event)) {
										resetAll();
										return;
									}
									updateCosting(event, setMemberId);
								}}
								min={0}
							/>
						</div>
					</div>
					<div className="costing-items-row d-flex align-items-center">
						<div className="left-half">
							<span className="regular-14 gray_dark_02">CM*</span>
						</div>
						<div className="right-half">
							<input
								type="number"
								placeholder="$00.00"
								disabled={readOnly}
								name="cmCost"
								value={inputData?.cmCost || ''}
								onKeyPress={validateFloatNumber}
								onChange={(e) => handleChange(e, setMemberId)}
								onFocus={(event) => (prevTarget.current = event.target.value)}
								onBlur={(event) => {
									if (!isValidInput(prevTarget, event)) {
										resetAll();
										return;
									}
									updateCosting(event, setMemberId);
								}}
								min={0}
							/>
						</div>
					</div>
					<div className="costing-items-row d-flex align-items-center">
						<div className="left-half">
							<span className="regular-14 gray_dark_02">Packaging</span>
						</div>
						<div className="right-half">
							<input
								type="number"
								placeholder="$00.00"
								disabled={readOnly}
								name="accessoriesCost"
								value={inputData?.accessoriesCost || ''}
								onKeyPress={validateFloatNumber}
								onChange={(e) => handleChange(e, setMemberId)}
								onFocus={(event) => (prevTarget.current = event.target.value)}
								onBlur={(event) => {
									if (!isValidInput(prevTarget, event)) {
										resetAll();
										return;
									}
									updateCosting(event, setMemberId);
								}}
								min={0}
							/>
						</div>
					</div>
					<div className="costing-items-row d-flex align-items-center">
						<div className="left-half">
							<span className="regular-14 gray_dark_02">Testing</span>
						</div>
						<div className="right-half">
							<input
								type="number"
								placeholder="$00.00"
								disabled={readOnly}
								name="testingCost"
								value={inputData?.testingCost || ''}
								onKeyPress={validateFloatNumber}
								onChange={(e) => handleChange(e, setMemberId)}
								onFocus={(event) => (prevTarget.current = event.target.value)}
								onBlur={(event) => {
									if (!isValidInput(prevTarget, event)) {
										resetAll();
										return;
									}
									updateCosting(event, setMemberId);
								}}
								min={0}
							/>
						</div>
					</div>
					<div className="costing-items-row d-flex align-items-center">
						<div className="left-half">
							<span className="regular-14 gray_dark_02">Commercial*</span>
						</div>
						<div className="right-half">
							<input
								type="number"
								placeholder="$00.00"
								disabled={readOnly}
								name="commercialCost"
								value={inputData?.commercialCost || ''}
								onKeyPress={validateFloatNumber}
								onChange={(e) => handleChange(e, setMemberId)}
								onFocus={(event) => (prevTarget.current = event.target.value)}
								onBlur={(event) => {
									if (!isValidInput(prevTarget, event)) {
										resetAll();
										return;
									}
									updateCosting(event, setMemberId);
								}}
								min={0}
							/>
						</div>
					</div>
					<div className="costing-items-row d-flex align-items-center">
						<div className="left-half">
							<span className="regular-14 gray_dark_02">Allowance</span>
						</div>
						<div className="right-half">
							<input
								type="number"
								placeholder="$00.00"
								disabled={readOnly}
								name="allowance"
								value={inputData?.allowance || ''}
								onKeyPress={validateFloatNumber}
								onChange={(e) => handleChange(e, setMemberId)}
								onFocus={(event) => (prevTarget.current = event.target.value)}
								onBlur={(event) => {
									if (!isValidInput(prevTarget, event)) {
										resetAll();
										return;
									}
									updateCosting(event, setMemberId);
								}}
								min={0}
							/>
						</div>
					</div>
				</>
			)}
			<div className="view-more-btn">
				{showMore && (
					<button className="button text size32" onClick={() => setShowMore(false)}>
						View less
					</button>
				)}
				{!showMore && (
					<button className="button text size32" onClick={() => setShowMore(true)}>
						View more
					</button>
				)}
			</div>
		</div>
	);
};

export default CostingFields;
